import { toRowStatus, type BpaRowFormValues } from "../schemas/manageFormSchemas";
import type { BpaRow } from "./bpaRows";

export function freshFormRow(row: BpaRow): BpaRowFormValues {
  return {
    id: row.id,
    assignedResearcherId: row.assignedResearcherId,
    assignedEditorId: row.assignedEditorId,
    status: toRowStatus(row.status),
  };
}

export function mergeFormRows(
  existing: BpaRowFormValues[],
  displayed: BpaRow[],
): BpaRowFormValues[] {
  const existingById = new Map(existing.map(entry => [entry.id, entry]));
  const seenIds = new Set<string>();
  const merged: BpaRowFormValues[] = [];

  for (const row of displayed) {
    if (seenIds.has(row.id)) {
      continue;
    }
    seenIds.add(row.id);
    merged.push(existingById.get(row.id) ?? freshFormRow(row));
  }

  return merged;
}
